import StockItPerformance from './stock-it-performance';
import {destandard} from '../../../utils/commonFunctions';
import './style.css';

const StockItPerformances = (props) => {
  const { performances } = props;

  return (
    <div>
      {
        performances.map((value, key) => {
          const performance = destandard({...value});
          return (
            performance.charts && performance.charts.length && (
              <div key={key}>
                <h3 className='store-name'>{performance.name}, {performance.customer_number}</h3>
                <StockItPerformance {...performance} key={key} index={key}/>
              </div>
            )
          ) || false;
        })
      }
    </div>
  );
};

export default StockItPerformances;

